export default __webpack_public_path__ + "static/media/Backback.e520c888.svg";